export default __webpack_public_path__ + "static/media/warning.3d1f56b0.png";